import _ from 'lodash';
import massSelect, { FULL_SELECTED } from '../../controllers/massSelect';

class MassChangeSelectMenu {
  #instance;

  #isTemplateLoaded = false;

  #selectMenuList;

  #selectMenuPopup;

  #selectMenuItemsConfig = [
    {
      id: 'idSelectAll',
      value: __('app_masschange_menu_sel_all'),
    },
    {
      id: 'idSelectCurrent',
      value: __('app_masschange_menu_sel_one'),
    },
    {
      id: 'idUnselectAll',
      value: __('app_masschange_menu_unsel_all'),
    },
    {
      id: 'idUnselectCurrent',
      value: __('app_masschange_menu_unsel_one'),
    },
  ];

  init(instance) {
    this.#instance = instance;

    if (!this.#isTemplateLoaded) {
      loadWebixTemplates();
      this.#isTemplateLoaded = true;
    }

    this.#selectMenuList = $$(innerViews.selectMenuList.id);
    this.#selectMenuPopup = $$(innerViews.main.id);
  }

  show(config) {
    const { anchorNode, taskId } = config;
    const menuItems = this.#composeMenuItemsData(+taskId);

    this.#selectMenuList.clearAll();
    this.#selectMenuList.parse(menuItems);

    if (!menuItems.length) {
      return;
    }

    this.#selectMenuPopup.show(anchorNode, { pos: 'bottom' });
  }

  hide() {
    if (this.#selectMenuPopup.isVisible()) {
      this.#selectMenuPopup.hide();
    }
  }

  #composeMenuItemsData(taskId) {
    const childCount = this.#instance.getChildren(taskId).length;
    const task = this.#instance.isTaskExists(taskId) && this.#instance.getTask(taskId);

    if (childCount === 0 || !task) {
      return [];
    }

    const selectState = massSelect.getEntrySelectionState(taskId);
    const isTaskSelected = massSelect.isTaskSelected(taskId);
    const menuItems = this.#selectMenuItemsConfig.map(item => this.#prepareMenuItem(item, taskId, selectState, isTaskSelected));

    if (task.type === this.#instance.config.types.project && !task.parent) {
      return menuItems.filter(item => item.id === 'idSelectAll' || item.id === 'idUnselectAll');
    }
  
    return menuItems;
  }

  #prepareMenuItem(item, taskId, selectState, isTaskSelected) {
    const preparedItem = { ...item };

    switch (preparedItem.id) {
    case 'idSelectAll':
      preparedItem.disabled = selectState === FULL_SELECTED;
      preparedItem.handler = () => {
        if (this.#instance.isTaskExists(taskId)) {
          massSelect.selectTask(taskId);
          userExtAnalytics.log('masschange_select_task', { from: 'context menu' });
        }
      };

      break;
    case 'idUnselectAll':
      preparedItem.disabled = selectState !== FULL_SELECTED;
      preparedItem.handler = () => {
        if (this.#instance.isTaskExists(taskId)) {
          massSelect.unselectTask(taskId);
          userExtAnalytics.log('masschange_unselect_task', { from: 'context menu' });
        }
      };

      break;
    case 'idSelectCurrent':
      preparedItem.disabled = isTaskSelected;
      preparedItem.handler = () => {
        if (this.#instance.isTaskExists(taskId)) {
          massSelect.selectTask(taskId, false);
          userExtAnalytics.log('masschange_select_task', { from: 'context menu' });
        }
      };

      break;
    case 'idUnselectCurrent':
      preparedItem.disabled = !isTaskSelected;
      preparedItem.handler = () => {
        if (this.#instance.isTaskExists(taskId)) {
          massSelect.unselectTask(taskId, false);
          userExtAnalytics.log('masschange_unselect_task', { from: 'context menu' });
        }
      };

      break;
    }

    return preparedItem;
  }
}

const innerTemplates = {
  menuItem: item => {
    if (item.disabled) {
      return `<span class="list-item-disabled">${item.value}</span>`;
    }

    return item.value;
  },
};

const innerViews = {
  main: {
    id: 'idViewPopupMcSelectMenu',
  },
  selectMenuList: {
    id: 'idViewMenuMcSelect',
    view: 'menu',
    css: 'context_menu_list select-menu',
    borderless: true,
    autoheight: true,
    layout: 'y',
    template: innerTemplates.menuItem,
    data: [],
    type: {
      height: 36,
    },
    on: {
      onItemClick(id, event, node) {
        const item = this.getItem(id);

        if (item.disabled) {
          return;
        }

        item.handler && item.handler(item, event, node);
        $$(innerViews.main.id).hide();
      },
    }
  }
};

function loadWebixTemplates() {
  // exclude webix templates from public url app

  webix.ui({
    id: innerViews.main.id,
    view: 'popupWithoutPoint',
    css: 'context_menu_popup',
    hidden: true,
    borderless: true,
    autoheight: true,
    width: 146,
    body: {
      rows: [
        innerViews.selectMenuList,
      ],
    },
    on: {
      onHide() {
        $$(innerViews.selectMenuList.id).clearAll();
      },
    },
  });
}

export default new MassChangeSelectMenu();
